export const SET_TRANSACTION_LIST = "SET_TRANSACTION_LIST";
export const SET_ACTUAL_TRANSACTIONLIST = "SET_ACTUAL_TRANSACTIONLIST";
export const RESET_PAYMENT_DATA = "RESET_PAYMENT_DATA";
export const GETPAYMENTHISTORY = "GETPAYMENTHISTORY";
export const GETPAYMENTHISTORY_SUCCESS = "GETPAYMENTHISTORY_SUCCESS";
export const GETPAYMENTHISTORY_FAILURE = "GETPAYMENTHISTORY_FAILURE";
export const SET_TOTAL_NUMBER_OF_RECORDS_PAYMENT = "SET_TOTAL_NUMBER_OF_RECORDS_PAYMENT";
export const SET_ACTIVE_PAGE_PAYMENT = "SET_ACTIVE_PAGE_PAYMENT";
export const SET_RECORDS_PERPAGE_PAYMENT = "SET_RECORDS_PERPAGE_PAYMENT";
export const SET_FILTERED_DATA_PAYMENT = "SET_FILTERED_DATA_PAYMENT";
export const SET_TABLE_DATA_PAYMENT = "SET_TABLE_DATA_PAYMENT";
export const SET_ACTION_NAME_PAYMENT = "SET_ACTION_NAME_PAYMENT";
export const SET_SLICED_DATA_PAYMENT = "SET_SLICED_DATA_PAYMENT";
export const SET_FULL_SEARCH_DATA_PAYMENT = "SET_FULL_SEARCH_DATA_PAYMENT";
export const SET_DATE_FROM_PAYMENT = "SET_DATE_FROM_PAYMENT";
export const SET_DATE_TO_PAYMENT = "SET_DATE_TO_PAYMENT";
export const SET_SORT_STATUS_INVOICE_NO = "SET_SORT_STATUS_INVOICE_NO";
export const SET_SORT_STATUS_TRANSACTION_NO = "SET_SORT_STATUS_TRANSACTION_NO";
export const SET_SORT_STATUS_PAYMENT_AMOUNT = "SET_SORT_STATUS_PAYMENT_AMOUNT";
export const SET_SORT_STATUS_PAYMENT_DATE = "SET_SORT_STATUS_PAYMENT_DATE";
export const SET_SORT_STATUS_PAYMENT_STATUS = "SET_SORT_STATUS_PAYMENT_STATUS";
export const SET_SORT_STATUS_PAYMENT_MODE = "SET_SORT_STATUS_PAYMENT_MODE";
export const SET_SEARCH_OR_REFRESH_PAYMENT = "SET_SEARCH_OR_REFESH_PAYMENT";
export const SET_PAGE_COUNT_PAYMENT = "SET_PAGE_COUNT_PAYMENT";
export const SET_CONTRACT_ACC_ID_PAYMENT = "SET_CONTRACT_ACC_ID_PAYMENT ";
export const LOAD_DATA_PAYMENT = "LOAD_DATA_PAYMENT";
export const SET_ALERT_MODAL_PAYMENT = "SET_ALERT_MODAL_PAYMENT";
export const SET_SHOW_MODAL_PAYMENT = "SET_SHOW_MODAL_PAYMENT";
export const SET_LOADER_PAYMENT = "SET_LOADER_PAYMENT";
export const MAKEPAYMENTHISTORYCALL = "MAKEPAYMENTHISTORYCALL";

export function loadData(value) {
  return {
    type: LOAD_DATA_PAYMENT,
    value,
  };
}

export function reset() {
  return {
    type: RESET_PAYMENT_DATA,
  };
}

export function setTransactionList(value) {
  return {
    type: SET_TRANSACTION_LIST,
    value,
  };
}

export function setActualTransactionList(value) {
  return {
    type: SET_ACTUAL_TRANSACTIONLIST,
    value,
  };
}

export const getPaymentHistory = (contractAccountId, callback) => {
  return {
    type: GETPAYMENTHISTORY,
    contractAccountId,
    callback,
  };
};

export const getPaymentHistorySuccess = (data) => {
  return {
    type: GETPAYMENTHISTORY_SUCCESS,
    data,
  };
};

export const getPaymentHistoryFailure = (error) => {
  return {
    type: GETPAYMENTHISTORY_FAILURE,
    error,
  };
};

export function setTotalNumberOfRecords(value) {
  return {
    type: SET_TOTAL_NUMBER_OF_RECORDS_PAYMENT,
    value,
  };
}
export function setActivePage(value) {
  return {
    type: SET_ACTIVE_PAGE_PAYMENT,
    value,
  };
}

export function setRecordsPerpage(value) {
  return {
    type: SET_RECORDS_PERPAGE_PAYMENT,
    value,
  };
}

export function setSlicedData(value) {
  return {
    type: SET_SLICED_DATA_PAYMENT,
    value,
  };
}

export function setFilteredData(value) {
  return {
    type: SET_FILTERED_DATA_PAYMENT,
    value,
  };
}

export function setPaymentTableData(value) {
  return {
    type: SET_TABLE_DATA_PAYMENT,
    value,
  };
}

export function setActionName(value) {
  return {
    type: SET_ACTION_NAME_PAYMENT,
    value,
  };
}

export function setFullSearchData(value) {
  return {
    type: SET_FULL_SEARCH_DATA_PAYMENT,
    value,
  };
}

export function setDateFrom(value) {
  return {
    type: SET_DATE_FROM_PAYMENT,
    value,
  };
}

export function setDateTo(value) {
  return {
    type: SET_DATE_TO_PAYMENT,
    value,
  };
}

export function setSortStatusInvoiceNo(value) {
  return {
    type: SET_SORT_STATUS_INVOICE_NO,
    value,
  };
}

export function setSortStatusTransactionNo(value) {
  return {
    type: SET_SORT_STATUS_TRANSACTION_NO,
    value,
  };
}

export function setSortStatusPaymentAmount(value) {
  return {
    type: SET_SORT_STATUS_PAYMENT_AMOUNT,
    value,
  };
}

export function setSortStatusPaymentDate(value) {
  return {
    type: SET_SORT_STATUS_PAYMENT_DATE,
    value,
  };
}

export function setSortStatusPaymentStatus(value) {
  return {
    type: SET_SORT_STATUS_PAYMENT_STATUS,
    value,
  };
}

export function setSortStatusPaymentMode(value) {
  return {
    type: SET_SORT_STATUS_PAYMENT_MODE,
    value,
  };
}

export function setSearchOrRefresh(value) {
  return {
    type: SET_SEARCH_OR_REFRESH_PAYMENT,
    value,
  };
}

export function setPageCount(value) {
  return {
    type: SET_PAGE_COUNT_PAYMENT,
    value,
  };
}

export function setContractAccId(value) {
  return {
    type: SET_CONTRACT_ACC_ID_PAYMENT,
    value,
  };
}
export function setAlertModal(value) {
  return {
    type: SET_ALERT_MODAL_PAYMENT,
    value,
  };
}
export function setShowModal(value) {
  return {
    type: SET_SHOW_MODAL_PAYMENT,
    value,
  };
}
export function setLoader(value) {
  return {
    type: SET_LOADER_PAYMENT,
    value,
  };
}
export const makePaymentHistoryCall = (data) => {
  return {
    type: MAKEPAYMENTHISTORYCALL,
    data,
  };
};
